import { Component } from "react";
import Select from "react-select";
import $ from "jquery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { adminlimit, baseUrl } from "../../Settings/Config";
import api from "../../../utils/axios";
import {
  showContaimerLoader,
  encodeValue,
  removeItem,
  showPageCount,
  removeChar,
  isEmpty,
  showLoader,
  hideLoader,
  showAlert,
  isSingleSelect,
  apiDate,
  showDBDate,
  showDBTime,
  showDateTime,
  hasPermission,
} from "../../Settings/Settings";
import Pagenation from "../../Layout/Pagenation";
const module = "candidateevaluation";
const modulePath = "/candidate";
const moduleName = "Evaluation";
const idName = "evaluation";
const evaluationTypeList = [
  { label: "OFF 47A DECK OFFICERS EVALUATION FORM", value: 2, evltype: "Officers Deck" },
  { label: "OFF 47B ENGINE OFFICERS EVALUATION FORM", value: 1, evltype: "Officers Engine" },
  { label: "OFF 47C EVALUTAION FORM DECK RATINGS", value: 3, evltype: "Engine Officers" },
  { label: "OFF 47D EVALUATION FORM ENGINE RATINGS", value: 4, evltype: "Engine Ratings" },
  { label: "OFF 47E GALLEY EVALUATION FORM", value: 5, evltype: "Galley Officers" },
];
const moduleID = 27;
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLimit: { label: adminlimit, value: adminlimit },
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      name: "",
      userList: [],
      rankList: [],
      vesselList: [],
      vesselTypeList: [],
      editID: "",
      postdata: {
        evaluationUser: "",
        evaluationrank: "",
        evaluationdate: "",
        evaluationtime: "",
        evaluationtype: "",
        evaluationLink: "",
      },
      detaildata: [],
      restForm: false,
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadList(1);
    this.loadDropdown();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader(`submit_${idName}_frm`);
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
  }
  searchList(e) {
    e.preventDefault();
    this.setState({ loading: true, currentPage: 1 }, () => {
      this.loadList(1);
    });
  }
  resetSearch(e) {
    e.preventDefault();
    this.setState(
      {
        loading: true,
        name: "",
        currentPage: 1,
      },
      () => {
        this.loadList(1);
      },
    );
  }
  loadList(offset) {
    this.setState({ loading: true });
    let addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }

    try {
      api
        .get(`${module}?limit=${this.state.pageLimit.value}&offset=${offset}&candidateId=${this.props.candidateID}${addParams}`)
        .then((res) => {
          if (res.data.status === "ok") {
            this.setState({ listdata: res.data.result, loading: false, totalRecords: res.data.totalRecords, totalPage: res.data.totalPages });
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({ loading: false, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
        });
    } catch (e) {
      this.setState({ loading: false, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
    }
  }
  loadDropdown() {
    api
      .get("user/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ userList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ userList: [] });
      });
  }
  edit(editID, e) {
    e.preventDefault();
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        () => {
          this.loadList(value);
        },
      );
    } else if (field === "pageLimit") {
      this.setState({ pageLimit: value, currentPage: 1 }, () => {
        this.loadList(1);
      });
    } else if (field === "restForm") {
      this.setState({ restForm: value });
    }
  };
  handleChangeText(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  removeItem(deleteID, e) {
    e.preventDefault();
    removeItem(deleteID, module, this.sateValChange, this.state.currentPage);
  }

  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }), () => {
      this.generateLink();
    });
  };
  generateLink() {
    const evaluationUser = this.state.postdata.evaluationUser?.value || "";
    const evaluationrank = this.state.postdata.evaluationrank?.value || "";
    const evaluationdate = this.state.postdata.evaluationdate;
    const evaluationtime = this.state.postdata.evaluationtime;
    const evaluationtype = this.state.postdata.evaluationtype?.value || "";
    console.log(evaluationUser, evaluationrank, evaluationdate, evaluationtime, evaluationtype, "evaluationtypeevaluationtypeevaluationtype");
    if (evaluationUser !== "" && evaluationrank !== "" && evaluationdate !== "" && evaluationtime !== "" && evaluationtype !== "") {
      this.setState(
        update(this.state, {
          postdata: {
            evaluationLink: {
              $set: `${baseUrl}candidate/evaluation/${this.props.candidateID}?appliedFor=${evaluationUser}&appliedRank=${encodeURIComponent(evaluationrank)}&appliedDate=${showDBDate(evaluationdate)}&appliedTime=${showDBTime(evaluationtime)}&appliedType=${evaluationtype}`,
            },
          },
        }),
      );
    }
  }

  handleSubmit = () => {
    showLoader(`submit_${idName}_frm`);
    const postData = this.state.postdata;

    const postObject = {
      candidateId: this.props.candidateID,
      evaluationUser: postData.evaluationUser?.value,
      evaluationrank: postData.evaluationrank?.value,
      evaluationdate: apiDate(postData.evaluationdate),
      evaluationtime: showDBTime(postData.evaluationtime),
      evaluationtype: postData.evaluationtype?.evltype ?? "",
      evaluationLink: postData.evaluationLink,
    };

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${encodeValue(this.state.editID)}`;
      method = "put";
    }
    api[method](post_url, postObject)
      .then((res) => {
        hideLoader(`submit_${idName}_frm`);
        $(".btn-close").trigger("click");
        const errMsg = res.data.message;
        if (res.data.status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.loadList(1);
          setTimeout(() => {
            this.resetFrom();
          }, 1000);
        }
      })
      .catch((err) => {
        hideLoader(`submit_${idName}_frm`);
        const errMsg = err.response.data?.message || err?.message;
        showAlert("Error", errMsg, "error", "No");
        console.error(err);
      });
  };
  closePopup() {
    setTimeout(() => {
      this.resetFrom();
    }, 1000);
  }
  resetFrom() {
    this.setState({
      editID: "",
      restForm: true,
      postdata: {
        company: "",
        evaluationrank: "",
        vessel: "",
        type: "",
        type_other: "",
        from1: "",
        evaluationtime: "",
      },
    });
  }

  render() {
    return (
      <div className="main-container container-fluid mx-3">
        <div className="page-header">
          <h1 className="page-title">{moduleName}</h1>
          <div>
            {hasPermission(moduleID, "add") && (
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <button
                    className="btn btn-sm btn-success badge mx-4"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target={`#${idName}modal`}
                    data-backdrop="static"
                    data-keyboard="false"
                    id={`addNew${idName}`}
                  >
                    <i className="fa fa-plus"></i> Create New
                  </button>
                </li>
              </ol>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              {this.state.loading ? (
                showContaimerLoader()
              ) : (
                <div>
                  <div className="card-header">
                    {parseInt(this.state.totalPage) > 0 && showPageCount(moduleName, this.state.currentPage, this.state.totalPage, this.state.totalRecords, this.sateValChange, this.state.pageLimit)}
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                        <thead className="table-primary">
                          <tr>
                            {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && <th className="text-center">Actions </th>}
                            <th>S.No.</th>
                            <th>Evaluation Type</th>
                            <th>Interviewer Email</th>
                            <th>Applied Rank</th>
                            <th>Applied Date Time</th>
                            <th>Remote Link</th>
                            <th>Applied By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.listdata.length > 0 ? (
                            this.state.listdata.map((item, index) => {
                              return (
                                <tr key={index}>
                                  {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && (
                                    <td className="text-center text-nowrap" valign="top">
                                      {hasPermission(moduleID, "edit") && (
                                        <a href={`/candidate/evaluation/${this.props.candidateID}?id=${item.id}`} target="_blank" className="me-2"  rel="noreferrer">
                                          <i className="fa fa-eye"></i>
                                        </a>
                                      )}
                                      {hasPermission(moduleID, "delete") && (
                                        <a href="/" className="delete_record" onClick={this.removeItem.bind(this, encodeValue(item.id))}>
                                          <i className="fa fa-trash"></i>
                                        </a>
                                      )}
                                    </td>
                                  )}
                                  <td>{(parseInt(this.state.currentPage) - 1) * parseInt(this.state.pageLimit.value) + (parseInt(index) + 1)}</td>
                                  <td>{item.eval_type}</td>
                                  <td>{item.interviewer_name}</td>
                                  <td>{item.applied_rank}</td>
                                  <td>{showDateTime(`${item.applied_date} ${item.time}`)}</td>
                                  <td>
                                    {item.values === "" || item.values === null ? (
                                      <a href={item.remote} target="_blank" rel="noreferrer">
                                        Copy Link
                                      </a>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                  <td>{item.applied_by}</td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td className="text-center" colSpan={15}>
                                No {moduleName} Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {parseInt(this.state.totalPage) > 1 && (
                      <Pagenation
                        params={{
                          totalRecords: this.state.totalRecords,
                          totalPage: this.state.totalPage,
                          currentPage: this.state.currentPage,
                        }}
                        sateValChange={this.sateValChange}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="modal fade" id={`${idName}modal`} tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{`${this.state.editID !== "" ? "Update" : "Add New"} ${moduleName}`}</h5>
                <button className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <PostForm
                {...this.props}
                fields={this.state.postdata}
                userList={this.state.userList}
                vesselList={this.state.vesselList}
                vesselTypeList={this.state.vesselTypeList}
                restForm={this.state.restForm}
                sateValChange={this.sateValChange}
                onChange={this.fieldChange}
                onValid={this.handleSubmit}
                closePopup={this.closePopup.bind(this)}
                editID={this.state.editID}
                error_msg={this.state.error_msg}
                onInvalid={() => {
                  console.log("Form invalid!");
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default List;

function validationConfig(props) {
  const { evaluationUser, evaluationrank, evaluationdate, evaluationtime, evaluationtype } = props.fields;

  return {
    fields: ["evaluationUser", "evaluationrank", "evaluationdate", "evaluationtime", "evaluationtype"],
    validations: {
      evaluationUser: [[isSingleSelect, evaluationUser]],
      evaluationrank: [[isSingleSelect, evaluationrank]],
      evaluationdate: [[isEmpty, evaluationdate]],
      evaluationtime: [[isEmpty, evaluationtime]],
      evaluationtype: [[isSingleSelect, evaluationtype]],
    },
  };
}
class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      restData: false,
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.restForm === true) {
      this.props.sateValChange("restForm", false);
      setTimeout(() => {
        this.handleReset();
      }, 1000);
    }
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChangeFile(name, value) {
    this.props.onChange(name, value);
  }
  handleFileChange = (e) => {
    const file = e.target.files[0];
    const name = e.target.name;
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      this.props.onChange(name, previewUrl);
    }
  };
  closePopup() {
    this.props.sateValChange("restForm", true);
  }
  handleReset = () => {
    const { $validation } = this.props;
    // 2️⃣ Reset all validation errors
    Object.keys($validation).forEach((key) => {
      if ($validation[key]) {
        $validation[key].show = false;
        $validation[key].error = {};
      }
    });
    this.setState({ restData: this.state.restData });
  };

  render() {
    const { fields, onValid, onInvalid, $validation } = this.props;
    let errMsgevaluationUser,
      errMsgevaluationrank,
      errMsgevaluationdate,
      errMsgevaluationtime,
      errMsgevaluationtype = "";
    if ($validation.evaluationUser.error.reason !== undefined) {
      errMsgevaluationUser = $validation.evaluationUser.show && <span className="error">{$validation.evaluationUser.error.reason}</span>;
    }
    if ($validation.evaluationrank.error.reason !== undefined) {
      errMsgevaluationrank = $validation.evaluationrank.show && <span className="error">{$validation.evaluationrank.error.reason}</span>;
    }

    if ($validation.evaluationdate.error.reason !== undefined) {
      errMsgevaluationdate = $validation.evaluationdate.show && <span className="error">{$validation.evaluationdate.error.reason}</span>;
    }
    if ($validation.evaluationtime.error.reason !== undefined) {
      errMsgevaluationtime = $validation.evaluationtime.show && <span className="error">{$validation.evaluationtime.error.reason}</span>;
    }
    if ($validation.evaluationtype.error.reason !== undefined) {
      errMsgevaluationtype = $validation.evaluationtype.show && <span className="error">{$validation.evaluationtype.error.reason}</span>;
    }

    return (
      <>
        <div>
          <div className="modal-body">
            <div className="form-group">
              <div className="form-row">
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Evaluation User<span className="lbl-error">*</span>
                  </label>
                  <Select value={fields.evaluationUser} onChange={this.handleSelectChange.bind(this, "evaluationUser")} placeholder="Select Evaluation User" options={this.props.userList} />
                  {errMsgevaluationUser}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Rank<span className="lbl-error">*</span>
                  </label>
                  <Select value={fields.evaluation} onChange={this.handleSelectChange.bind(this, "evaluationrank")} placeholder="Select Rank" options={this.props.rankList} />
                  {errMsgevaluationrank}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Applied Date<span className="lbl-error">*</span>
                  </label>
                  <DatePicker
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Select Applied Date"
                    className="form-control"
                    onKeyDown={(e) => e.preventDefault()}
                    selected={fields.evaluationdate}
                    dateFormat="dd-MM-yyyy"
                    onChange={this.handleSelectChange.bind(this, "evaluationdate")}
                    minDate={new Date()}
                  />
                  {errMsgevaluationdate}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Time<span className="lbl-error">*</span>
                  </label>
                  <DatePicker
                    selected={fields.evaluationtime}
                    onChange={this.handleSelectChange.bind(this, "evaluationtime")}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    className="form-control"
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                  />
                  {errMsgevaluationtime}
                </div>
                <div className="form-group col-md-6">
                  <label className="form-label">
                    Evaluation Type<span className="lbl-error">*</span>
                  </label>
                  <Select value={fields.evaluationtype} onChange={this.handleSelectChange.bind(this, "evaluationtype")} placeholder="Select Evaluation Type" options={evaluationTypeList} />
                  {errMsgevaluationtype}
                </div>
                <div className="form-group col-md-12">
                  <label className="form-label">Remote Link</label>
                  <input type="text" className="form-control" readOnly placeholder="Remote Link" name="evaluationLink" value={fields.evaluationLink} />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.closePopup.bind(this)}>
              Close
            </button>
            <button
              className="btn btn-primary"
              id={`submit_${idName}_frm`}
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Save changes
            </button>
          </div>
        </div>
      </>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
